import { widgetsLibrary } from '../widgetsLibrary/widgetsLibrary'

export const commonWidgets: CommonWidget = {
  ...widgetsLibrary
}
